// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { Loading } from "@/layouts/loading";
import { PharmacySize, StockPointType } from "@/gen/auth/common_pb";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/inventory/add-stock/")({
    component: Component,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
    loader: async (): Promise<{
            stockPointId?: string;
        }> => {
            let stockPointId = undefined
            if (PharmacySize.SIZE_SMALL.toString() === localStorage.getItem('pharmacySize')) {
                const stockPoints = await pharmacyClient.getStockPoints({})
                for (const sp of stockPoints.stockPoints) {
                if (sp.stockPointType === StockPointType.RECEIVING) {
                    stockPointId = sp.id
                    break
                }
                }
            }
            
            return {
                stockPointId,
            }
        }
});